/// <reference path="../_all.ts" />

declare var pglob: IPhotometerGlobalVar;

module misc {
  'use strict';

	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class HomeCarruselCtrl {

    //private todos: TodoItem[];

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope'
      , '$timeout'
      , '$interval'
      , 'visibilityApiService'
      , '$element'
      , '$q'
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IHomeCarruselScope
      , private $timeout: ng.ITimeoutService
      , private $interval: ng.IIntervalService
      , private visibilityApiService: navigation.IVisibilityApiService
      , private $element: ng.IRootElementService
      , private $q: ng.IQService
    ) {

      visibilityApiService.subscribeOnVisibilityChange($scope, (ev: ng.IAngularEvent, isHidden: boolean) => {
        if (isHidden) {
          this.$interval.cancel(this.$scope.interval);
          this.$timeout.cancel(this.$scope.timeout);
        } else {
          this.resetTimer();
        }
      });

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.currentPageNr = 0;
      $scope.currentPreloadNr = 0;
      $scope.imageToLoad = 0;
      $scope.imageQueue = [];

      $scope.interval = $interval(() => { this.checkPageChange(); }, 200);

      $scope.lastChange = new Date().getTime();

      $scope.maxPageNr = $($element).find(".carussel > *").length;

      $scope.$watch('currentPageNr', function (newVal, oldVal) {
        if (newVal === -1) {
          $scope.currentPageNr = $scope.maxPageNr - 1;
        }
        var page = ($scope.currentPageNr % $scope.maxPageNr) * 100;
        $scope.transform = "translateX(-" + page + "vw)";
      })

      $scope.registerImg = function (index, url) {
        $timeout(() => $scope.imageQueue.push({ url: url, index: index, loaded: false, loading: false }));
      }

    }

    waitTime: number = 6000;
    readonly defaultShortWait: number = 6000;
    readonly defaultLongWait: number = 20000;

    resetTimer() {
      this.$scope.lastChange = new Date().getTime();
      this.waitTime = this.defaultLongWait;
    }



    getImageByIndex(index: number): { url: string, index: number, loaded: boolean, loading: boolean } {
      var i = this.$scope.imageQueue.filter(im => im.index === index);
      if (i.length > 0) return i[0];
      return null;
    }

    preloadImg(index: number) {
      if (index > this.$scope.currentPageNr + 1) return;
      var img = this.getImageByIndex(index);
      if (!img || img.loaded) {
        this.preloadImg(index + 1);
        return;
      }


      if (img.loading) return;
      if (!img) return;

      const image = new Image();
      image.onload = () => {
        $(this.$element).find(".carussel > *")[img.index].setAttribute("style", "background-image: url(" + img.url + ");");
        img.loaded = true;
        this.$scope.imageToLoad++;
        this.preloadImg(index + 1);
      }
      image.src = img.url;
      img.loading = true;
    }

    checkPageChange() {
      this.preloadImg(this.$scope.currentPageNr);
      if (new Date().getTime() - this.$scope.lastChange > this.waitTime) {
        var desiredPage = this.$scope.currentPageNr + 1;
        if (!this.getImageByIndex(desiredPage) || this.getImageByIndex(desiredPage).loaded) {
          if (this.waitTime == this.defaultLongWait) this.waitTime = this.defaultShortWait;
          this.$scope.currentPageNr++;
          this.$scope.lastChange = new Date().getTime();
          this.preloadImg(this.$scope.currentPageNr + 1);
        }
      }
    }


  }
}